import guideBottom from '@/components/guideBottom.vue';
export default {
  name: 'article',
  data() {
    return {
      detail: {}
    };
  },
  components: {
    guideBottom
  },
  methods: {
    getData() {
      let formData = {
        page: 1,
        limit: 10,
        deptId: this.$route.query.fid,
        formId: 349944,
        orderType: 'asc'
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        this.detail.title = this.getFormData(res.dataList[0], 1, 'val');
        this.detail.content = this.getFormData(res.dataList[0], 13, 'val');
        document.title = this.detail.title;
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    }
  },
  created() {
    this.getData();
  },
  computed: {}
};